import type { ReactNode } from 'react';

import RouterLink from './RouterLink';

import ExpandIcon from '@/assets/icons/content/expand.svg';

import classes from './SeeMoreLink.module.css';

type SeeMoreLinkProps = { to: string; children?: never } | { children: ReactNode; to?: never };

const hasTo = (props: SeeMoreLinkProps): props is { to: string; children?: never } =>
  typeof (props as { to?: string }).to === 'string';

const SeeMoreLink = (props: SeeMoreLinkProps) => {
  if (hasTo(props)) {
    const { to } = props;

    return (
      <span className={classes.link}>
        <RouterLink to={to}>
          <span>See more</span>
          <ExpandIcon />
        </RouterLink>
      </span>
    );
  }

  const { children } = props;

  return <span className={classes.link}>{children}</span>;
};

export default SeeMoreLink;
